import styles from "./PageIntro.module.css";

/**
 * The line or two at the top of an administration tab that says what the tab is for, before its panels. Every tab that has one uses
 * this, so they read alike.
 */
export function PageIntro({ children }: { children: React.ReactNode }): React.JSX.Element {
  return <p className={styles.intro}>{children}</p>;
}
